import React from "react";
import Footer from "../../components/footer/footer";
import Topbar from "../../components/topbar/topbar";
import "../termsandcondition/terms.css";
import { useTranslation, Trans } from "react-i18next";

export default function Privacy() {
  const { t } = useTranslation("legalPrivacy");
  return (
    <>
      <Topbar />
      <div>
        <h1 className="single-title page-title entry-title">{t("title")}</h1>{" "}
        <div className="terms-container">
          <section
            className="has_eae_slider elementor-section elementor-top-section elementor-element elementor-element-54ebfd94 trms elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="54ebfd94"
            data-element_type="section"
          >
            <div className="elementor-container elementor-column-gap-default">
              <div
                className="has_eae_slider elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-1e99a27"
                data-id="1e99a27"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div
                    className="elementor-element elementor-element-42142a3b elementor-widget elementor-widget-text-editor"
                    data-id="42142a3b"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p className="terms-date">
                        {t("lastModified")}
                      </p>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-2a6cbd37 elementor-widget elementor-widget-heading"
                    data-id="2a6cbd37"
                    data-element_type="widget"
                    data-settings='{"_animation":"none"}'
                    data-widget_type="heading.default"
                  >
                    <div className="elementor-widget-container">
                      <h2 className="elementor-heading-title elementor-size-default">
                        {t("intro.title")}{" "}
                      </h2>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-229921ef elementor-widget elementor-widget-text-editor"
                    data-id="229921ef"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>
                        <Trans i18nKey="intro.p1" ns="legalPrivacy" components={{ strong: <strong /> }} />
                      </p>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-13573d68 elementor-widget elementor-widget-text-editor"
                    data-id="13573d68"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>
                        <Trans i18nKey="intro.p2" ns="legalPrivacy" components={{ link1: <a href="https://verysoul.com" /> }} />
                      </p>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-3353ed23 elementor-widget elementor-widget-text-editor"
                    data-id="3353ed23"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>{t("intro.appliesTo")}</p>
                      <ul>
                        <li>{t("intro.appliesList.i1")}</li>
                        <li>{t("intro.appliesList.i2")}</li>
                        <li>{t("intro.appliesList.i3")}</li>
                        <li>{t("intro.appliesList.i4")}</li>
                        <li>{t("intro.appliesList.i5")}</li>
                      </ul>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-196b98f5 elementor-widget elementor-widget-text-editor"
                    data-id="196b98f5"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>{t("intro.notApplies")}</p>
                      <ul>
                        <li>{t("intro.notAppliesList.i1")}</li>
                        <li>{t("intro.notAppliesList.i2")}</li>
                      </ul>
                      <p>{t("intro.p3")}</p>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-262794ec elementor-widget elementor-widget-heading"
                    data-id="262794ec"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <div className="elementor-widget-container">
                      <h2 className="elementor-heading-title elementor-size-default">
                        {t("children.title")}
                      </h2>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-6946271 elementor-widget elementor-widget-text-editor"
                    data-id="6946271"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>
                        <Trans i18nKey="children.p1" ns="legalPrivacy" components={{ mail: <a href="mailto:privacy@verysoul.com" /> }} />
                      </p>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-7b251e1d elementor-widget elementor-widget-heading"
                    data-id="7b251e1d"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <div className="elementor-widget-container">
                      <h2 className="elementor-heading-title elementor-size-default">
                        {t("collect.title")}
                      </h2>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-95c76d3 elementor-widget elementor-widget-text-editor"
                    data-id="95c76d3"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>{t("collect.p1")}</p>
                      <ul>
                        <li>{t("collect.list1.i1")}</li>
                        <li>{t("collect.list1.i2")}</li>
                        <li>{t("collect.list1.i3")}</li>{" "}
                      </ul>
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-192166c3 elementor-widget elementor-widget-text-editor"
                    data-id="192166c3"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>{t("collect.p2")}</p>
                      <ul>
                        <li>{t("collect.list2.i1")}</li>
                        <li>{t("collect.list2.i2")}</li>
                        <li>{t("collect.list2.i3")}</li>
                      </ul>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-4f336467 elementor-widget elementor-widget-heading"
                    data-id="4f336467"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <div className="elementor-widget-container">
                      <h2 className="elementor-heading-title elementor-size-default">
                        {t("provide.title")}
                      </h2>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-49e1d7c0 elementor-widget elementor-widget-text-editor"
                    data-id="49e1d7c0"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>{t("provide.p1")}</p>
                      <ul>
                        <li>{t("provide.list.i1")}</li>
                        <li>{t("provide.list.i2")}</li>
                        <li>{t("provide.list.i3")}</li>
                        <li>{t("provide.list.i4")}</li>
                        <li>{t("provide.list.i5")}</li>
                      </ul>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-32bd242 elementor-widget elementor-widget-text-editor"
                    data-id="32bd242"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>
                        <Trans i18nKey="provide.p2" ns="legalPrivacy" components={{ strong: <strong /> }} />
                      </p>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-1eca30f9 elementor-widget elementor-widget-heading"
                    data-id="1eca30f9"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <div className="elementor-widget-container">
                      <h2 className="elementor-heading-title elementor-size-default">
                        {t("automatic.title")}
                      </h2>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-38ec0b8 elementor-widget elementor-widget-text-editor"
                    data-id="38ec0b8"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>{t("automatic.p1")}</p>
                      <ul>
                        <li>{t("automatic.list1.i1")}</li>
                        <li>{t("automatic.list1.i2")}</li>
                      </ul>
                      <p>{t("automatic.p2")}</p>
                      <p>{t("automatic.p3")}</p>
                      <ul>
                        <li>{t("automatic.list2.i1")}</li>
                        <li>{t("automatic.list2.i2")}</li>
                        <li>{t("automatic.list2.i3")}</li>
                        <li>{t("automatic.list2.i4")}</li>
                      </ul>
                      <p>{t("automatic.p4")}</p>
                      <ul>
                        <li>
                          <Trans i18nKey="automatic.cookies" ns="legalPrivacy" components={{ strong: <strong /> }} />
                        </li>
                      </ul>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-7c8b65a3 elementor-widget elementor-widget-text-editor"
                    data-id="7c8b65a3"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <ul>
                        <li>
                          <Trans i18nKey="automatic.flashCookies" ns="legalPrivacy" components={{ strong: <strong /> }} />
                        </li>
                      </ul>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-61058b96 elementor-widget elementor-widget-text-editor"
                    data-id="61058b96"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <ul>
                        <li>
                          <Trans i18nKey="automatic.webBeacons" ns="legalPrivacy" components={{ strong: <strong />, link1: <a href="#" /> }} />
                        </li>
                      </ul>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-4af87f6e elementor-widget elementor-widget-text-editor"
                    data-id="4af87f6e"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>{t("automatic.p5")}</p>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-3d06ab1d elementor-widget elementor-widget-heading"
                    data-id="3d06ab1d"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <div className="elementor-widget-container">
                      <h2 className="elementor-heading-title elementor-size-default">
                        {t("thirdParty.title")}{" "}
                      </h2>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-3548853e elementor-widget elementor-widget-text-editor"
                    data-id="3548853e"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>{t("thirdParty.p1")}</p>
                      <p>
                        {t("thirdParty.p2")}{" "}
                      </p>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-177cd868 elementor-widget elementor-widget-heading"
                    data-id="177cd868"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <div className="elementor-widget-container">
                      <h2 className="elementor-heading-title elementor-size-default">
                        {t("use.title")}
                      </h2>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-1aa623ae elementor-widget elementor-widget-text-editor"
                    data-id="1aa623ae"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>{t("use.p1")}</p>
                      <ul>
                        <li>{t("use.list.i1")}</li>
                        <li>{t("use.list.i2")}</li>
                        <li>{t("use.list.i3")}</li>
                        <li>{t("use.list.i4")}</li>
                        <li>{t("use.list.i5")}</li>
                        <li>{t("use.list.i6")}</li>
                        <li>{t("use.list.i7")}</li>
                        <li>{t("use.list.i8")}</li>
                        <li>{t("use.list.i9")}</li>
                        <li>{t("use.list.i10")}</li>
                      </ul>
                      <p>{t("use.p2")}</p>
                      <p>{t("use.p3")}</p>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-34849b2b elementor-widget elementor-widget-heading"
                    data-id="34849b2b"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <div className="elementor-widget-container">
                      <h2 className="elementor-heading-title elementor-size-default">
                        {t("disclosure.title")}
                      </h2>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-456a6991 elementor-widget elementor-widget-text-editor"
                    data-id="456a6991"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>
                        <span className="font-400">
                          {t("disclosure.p1")}
                        </span>
                      </p>
                      <p>
                        <span className="font-400">
                          {t("disclosure.p2")}
                        </span>
                      </p>
                      <ul>
                        <li className="font-400" aria-level="1">
                          <span className="font-400">
                            {t("disclosure.list1.i1")}
                          </span>
                        </li>
                        <li className="font-400" aria-level="1">
                          <span className="font-400">
                            {t("disclosure.list1.i2")}
                          </span>
                        </li>
                        <li className="font-400" aria-level="1">
                          <span className="font-400">
                            {t("disclosure.list1.i3")}
                          </span>
                        </li>
                        <li className="font-400" aria-level="1">
                          <span className="font-400">
                            {t("disclosure.list1.i4")}
                          </span>
                        </li>
                        <li className="font-400" aria-level="1">
                          <span className="font-400">
                            {t("disclosure.list1.i5")}
                          </span>
                        </li>
                        <li className="font-400" aria-level="1">
                          <span className="font-400">
                            {t("disclosure.list1.i6")}
                          </span>
                        </li>
                        <li className="font-400" aria-level="1">
                          <span className="font-400">
                            {t("disclosure.list1.i7")}
                          </span>
                        </li>
                      </ul>
                      <p>
                        <span className="font-400">
                          {t("disclosure.p3")}
                        </span>
                      </p>
                      <ul>
                        <li className="font-400" aria-level="1">
                          <span className="font-400">
                            {t("disclosure.list2.i1")}
                          </span>
                        </li>
                        <li className="font-400" aria-level="1">
                          <Trans i18nKey="disclosure.list2.i2" ns="legalPrivacy" components={{ span: <span className="font-400" />, link1: <a href="https://VerySoul.com/terms-conditions" /> }} />
                        </li>
                        <li className="font-400" aria-level="1">
                          <span className="font-400">
                            {t("disclosure.list2.i3")}
                          </span>
                        </li>
                      </ul>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-17156e2b elementor-widget elementor-widget-heading"
                    data-id="17156e2b"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <div className="elementor-widget-container">
                      <h2 className="elementor-heading-title elementor-size-default">
                        {t("choices.title")}
                      </h2>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-5292f28b elementor-widget elementor-widget-text-editor"
                    data-id="5292f28b"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>{t("choices.p1")}</p>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-791af5b7 elementor-widget elementor-widget-text-editor"
                    data-id="791af5b7"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <ul>
                        <li>
                            <Trans i18nKey="choices.tracking" ns="legalPrivacy" components={{ strong: <strong /> }} />
                        </li>
                      </ul>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-21dcb14d elementor-widget elementor-widget-text-editor"
                    data-id="21dcb14d"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <ul>
                        <li>
                            <Trans i18nKey="choices.thirdPartyAds" ns="legalPrivacy" components={{ strong: <strong />, mail: <a href="mailto:privacy@verysoul.com" /> }} />
                        </li>
                      </ul>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-51b77938 elementor-widget elementor-widget-text-editor"
                    data-id="51b77938"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <ul>
                        <li>
                            <Trans i18nKey="choices.promotional" ns="legalPrivacy" components={{ strong: <strong />, mail: <a href="mailto:privacy@verysoul.com" /> }} />
                        </li>
                      </ul>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-62e4896e elementor-widget elementor-widget-text-editor"
                    data-id="62e4896e"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>
                        {" "}
                        <Trans i18nKey="choices.nai" ns="legalPrivacy" components={{ strong: <strong />, link1: <a href="https://optout.networkadvertising.org/?c=1" /> }} />
                        {" "}
                      </p>
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-347e0090 elementor-widget elementor-widget-text-editor"
                    data-id="347e0090"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>{t("choices.california")}</p>
                      <p>
                        <Trans i18nKey="choices.nevada" ns="legalPrivacy" components={{ strong: <strong />, u1: <span className="text-underline" />, mail: <a href="mailto:privacy@verysoul.com" /> }} />
                      </p>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-61b5b480 elementor-widget elementor-widget-heading"
                    data-id="61b5b480"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <div className="elementor-widget-container">
                      <h2 className="elementor-heading-title elementor-size-default">
                        {t("access.title")}
                      </h2>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-1448a805 elementor-widget elementor-widget-text-editor"
                    data-id="1448a805"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>{t("access.p1")}</p>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-52d3091e elementor-widget elementor-widget-text-editor"
                    data-id="52d3091e"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>
                        <Trans i18nKey="access.p2" ns="legalPrivacy" components={{ strong: <strong />, u1: <span className="text-underline" />, link1: <a href={process.env.REACT_APP_SUPPORT_URL} target="_blank" /> }} />
                      </p>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-6eed90ac elementor-widget elementor-widget-text-editor"
                    data-id="6eed90ac"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>
                        <Trans i18nKey="access.p3" ns="legalPrivacy" components={{ link1: <a href="https://verysoul.com/terms-conditions/" /> }} />
                      </p>
                      <p>{t("access.p4")}</p>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-1f570944 elementor-widget elementor-widget-heading"
                    data-id="1f570944"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <div className="elementor-widget-container">
                      <h2 className="elementor-heading-title elementor-size-default">
                        {t("california.title")}
                      </h2>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-624ad1e6 elementor-widget elementor-widget-text-editor"
                    data-id="624ad1e6"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>
                        <Trans i18nKey="california.p1" ns="legalPrivacy" components={{ br: <br /> }} />{" "}
                      </p>
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-2a9f0219 elementor-widget elementor-widget-spacer"
                    data-id="2a9f0219"
                    data-element_type="widget"
                    data-widget_type="spacer.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner"></div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-7e11bcc5 elementor-widget elementor-widget-heading"
                    data-id="7e11bcc5"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <div className="elementor-widget-container">
                      <h2 className="elementor-heading-title elementor-size-default">
                        {t("outsideUS.title")}
                      </h2>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-7e339cb3 elementor-widget elementor-widget-text-editor"
                    data-id="7e339cb3"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>{t("outsideUS.p1")}</p>
                      <p>{t("outsideUS.p2")}</p>
                      <p>{t("outsideUS.p3")}</p>
                      <ul>
                        <li>{t("outsideUS.list.i1")}</li>
                        <li>{t("outsideUS.list.i2")}{" "}</li>
                        <li>{t("outsideUS.list.i3")}</li>
                        <li>{t("outsideUS.list.i4")}</li>
                        <li>{t("outsideUS.list.i5")}</li>
                      </ul>
                      <p>{t("outsideUS.p4")}</p>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-69971f3b elementor-widget elementor-widget-heading"
                    data-id="69971f3b"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <div className="elementor-widget-container">
                      <h2 className="elementor-heading-title elementor-size-default">
                        {t("security.title")}
                      </h2>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-5c05b6e8 elementor-widget elementor-widget-text-editor"
                    data-id="5c05b6e8"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>{t("security.p1")}</p>
                      <p>{t("security.p2")}</p>
                      <p>{t("security.p3")}</p>{" "}
                      <p>
                        <Trans i18nKey="security.google" ns="legalPrivacy" components={{ link1: <a href="https://developers.google.com/terms/api-services-user-data-policy" target="_blank" /> }} />
                      </p>
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-68f6ffda elementor-widget elementor-widget-heading"
                    data-id="68f6ffda"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <div className="elementor-widget-container">
                      <h2 className="elementor-heading-title elementor-size-default">
                        {t("changes.title")}
                      </h2>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-101f64a9 elementor-widget elementor-widget-text-editor"
                    data-id="101f64a9"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>{t("changes.p1")}</p>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-6b59ff72 elementor-widget elementor-widget-heading"
                    data-id="6b59ff72"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <div className="elementor-widget-container">
                      <h2 className="elementor-heading-title elementor-size-default">
                        {t("contact.title")}
                      </h2>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-6b6ffb41 elementor-widget elementor-widget-text-editor"
                    data-id="6b6ffb41"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>
                        <Trans i18nKey="contact.p1" ns="legalPrivacy" components={{ strong: <strong />, u1: <span className="text-underline" />, mail: <a href="mailto:privacy@verysoul.com" /> }} />
                      </p>
                      <p>
                        <Trans i18nKey="contact.p2" ns="legalPrivacy" components={{ u2: <span style={{ textDecoration: "underline" }} />, mail2: <a href="mailto:concerns@verysoul.com" /> }} />
                      </p>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            className="has_eae_slider elementor-section elementor-top-section elementor-element elementor-element-34fa84e4 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="34fa84e4"
            data-element_type="section"
          >
            <div className="elementor-container elementor-column-gap-default">
              <div
                className="has_eae_slider elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-67098d1c"
                data-id="67098d1c"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div
                    className="elementor-element elementor-element-49d07b97 elementor-widget elementor-widget-text-editor"
                    data-id="49d07b97"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p className="text-center">
                        <span className="font-400">
                          {t("copyright")}
                        </span>
                      </p>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </>
  );
}
